import { axiosInstance } from "../../config/index";
import {
  PIECHART_DATA_FETCHED,
  LINECHART_DATA_FETCHED,
  CARD_DATA_FETCHED,
} from "../types";

export const getPieChartData = () => (dispatch: any) => {
  return axiosInstance
    .get(`/api/dashboard/report/piechart`)
    .then((res) => {
      dispatch({
        type: PIECHART_DATA_FETCHED,
        pieChartData: res.data.weeklyPieData,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const getLineChartData = () => (dispatch: any) => {
  return axiosInstance
    .get(`/api/dashboard/report/linechart`)
    .then((res) => {
      dispatch({
        type: LINECHART_DATA_FETCHED,
        lineChartData: res.data.requestWeeklyTrend,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const getCardData = () => (dispatch: any) => {
  return axiosInstance
    .get(`/api/dashboard/report/carddata`)
    .then((res) => {
      dispatch({
        type: CARD_DATA_FETCHED,
        cardData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};



